import React from 'react';
import { withTranslation, WithTranslation } from "react-i18next";
import { translate } from '../../../I18n/i18n';
import { Button } from '@cuatroochenta/co-admin-react-library';



interface SyncDocumentsViewProps {
    onClick: () => void;
}

class SyncDocumentsView extends React.Component<SyncDocumentsViewProps & WithTranslation> {

    public render() {
        const { t } = this.props;
        return (
            <div>
                <Button
                    className="btn mt-4"
                    onClick={this.props.onClick}
                    content={translate(t, 'sync.TR_SYNC_LABEL')}
                />
            </div>
        );
    }
}

export default withTranslation()(SyncDocumentsView);